import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius-pill)] text-[15px] font-medium leading-none transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-burgundy-500)] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--color-burgundy-700)] text-[var(--color-ivory)] hover:bg-[var(--color-burgundy-900)]",
        destructive:
          "bg-[var(--color-danger)] text-[var(--color-ivory)] hover:bg-[var(--color-danger)]/90",
        outline:
          "border-[1.5px] border-[var(--color-burgundy-700)] bg-transparent text-[var(--color-burgundy-700)] hover:bg-[var(--color-burgundy-100)]",
        secondary:
          "border-[1.5px] border-[var(--color-burgundy-700)] bg-transparent text-[var(--color-burgundy-700)] hover:bg-[var(--color-burgundy-100)]",
        ghost: "rounded-none px-4 text-[var(--color-charcoal)] hover:text-[var(--color-burgundy-700)] hover:underline",
        link: "rounded-none px-0 text-[var(--color-burgundy-700)] underline-offset-4 hover:underline",
      },
      size: {
        default: "min-h-12 px-7 py-3.5",
        sm: "min-h-9 px-4 py-2 text-xs",
        lg: "min-h-12 px-9 py-3.5",
        icon: "h-10 w-10 p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
